
export enum ComparablesRadioButtonValues {
    No = 'NO',
    Yes = 'YES',
    Unknown = 'UNKNOWN'
}
